export default "__VITE_ASSET__Jkvw5Lz5__"